import React from 'react';
import { ShieldX } from 'lucide-react';
import { useAuth } from '../hooks';
import { Button } from './shared';
import { EmptyState } from './ui/empty-state';
import { ASSIGNMENT_ACCESS_DENIAL } from '../constants';

/**
 * @param {string} [props.reason] ASSIGNMENT_ACCESS_DENIAL code from the API error
 *   body. Only INSTITUTE_RESTRICTED gets its own wording — anything else (or a
 *   missing code, e.g. an older backend) falls back to the generic message.
 */
const AccessDenied = ({ reason }) => {
  const { user, signOut } = useAuth();
  const isInstituteRestricted = reason === ASSIGNMENT_ACCESS_DENIAL.INSTITUTE_RESTRICTED;

  const signedInAs = (
    <span className="block mt-2">
      You&apos;re signed in as <strong className="text-foreground">{user?.email ?? ''}</strong>
    </span>
  );

  return (
    <EmptyState
      icon={ShieldX}
      title={isInstituteRestricted ? 'Access Restricted' : "You can't access this link"}
      description={
        isInstituteRestricted ? (
          <>
            {signedInAs}
            <span className="block mt-2">
              This link can only be accessed using your school-provided email address.
            </span>
            <span className="block mt-2">
              Please switch to your school email account. Make sure there are no spelling errors
              in the email ID when signing in.
            </span>
          </>
        ) : (
          <>
            {signedInAs}
            <span className="block mt-2">
              You may not have permission to access this document, or it may not be available.
              Request access from your admin or sign in with a different account.
            </span>
          </>
        )
      }
      action={
        <Button className="mt-6" onClick={signOut}>
          Switch Account
        </Button>
      }
      className="h-[70vh]"
    />
  );
};

export default AccessDenied;
